export const clientConfigMap = {
  default: {
    ui: {
      coloredCardHubValues: false, // цветное выделение значений в карточке клиента в задании и кейсе
      useCityFilterInTask: true, // фильтр по городу в задании
      useLpuFilterInTask: true, // фильтр по лпу в задании
      resetServiceFilterOnBulkUpdate: true, // сброс отфильтрованных услуг при массовых изменениях в кейсе
      hideServicesFilterOnScroll: false, // прокрутка фильтра при скролле талбицы внутри кейса
      cloudExpertiseOnly: true, // выгрузка по облаку - только очная экспертиза
      cloudFullInformation: true, // выгрузка по облаку - получить полную информацию
      cloudDownloadTypes: false, // выгрузка по облаку - выпадающий список выгрузок
      progressBarType: 'percent', // выгрузка по облаку - тип прогрессбара
      showSendResultButton: false, // показать кнопку отправки результата в карточке задания
    },
  },
  zetta: {
    ui: {
      coloredCardHubValues: true,
      useCityFilterInTask: false,
      useLpuFilterInTask: false,
      resetServiceFilterOnBulkUpdate: false,
      hideServicesFilterOnScroll: true,
      cloudExpertiseOnly: false,
      cloudFullInformation: false,
      cloudDownloadTypes: true,
      progressBarType: 'default',
      showSendResultButton: false,
    },
  },
};

// Точечные UI-оверрайды по имени организации для клиентов без ui_profile.
export const organizationConfigMap = {
  Абсолют: {
    ui: {
      showSendResultButton: true,
    },
  },
};
